import { cn } from "@/lib/utils";

export const Container = ({ className, children }) => (
  <div className={cn("mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-12", className)}>
    {children}
  </div>
);

export const Section = ({ className, id, testid, children }) => (
  <section id={id} data-testid={testid} className={cn("py-16 sm:py-24 lg:py-32", className)}>
    {children}
  </section>
);

export const SectionHeading = ({ eyebrow, title, description, align = "left", testid, as: Tag = "h2" }) => (
  <div
    data-testid={testid}
    className={cn("max-w-2xl space-y-4", align === "center" && "mx-auto text-center")}
  >
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <Tag className="font-display text-2xl font-bold tracking-tight text-brand-snow sm:text-3xl lg:text-4xl">
      {title}
    </Tag>
    {description && <p className="text-sm leading-relaxed text-brand-mist sm:text-base">{description}</p>}
  </div>
);
